<div class="flex flex-wrap">
  <div class="w-full md:w-4/12 px-4 text-center">
    <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
      <div class="px-4 py-5 flex-auto">
        <div
          class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-red-400">
          <i class="fas fa-language">
          </i>
        </div>
        <p class="font-bold text-blueGray-700 mt-8" *ngIf='titles'>
          {{titles[0]}}
        </p>
        <p class="mt-2 mb-4 text-blueGray-500" *ngIf='titles'>
          {{texts[0]}}
        </p>
      </div>
    </div>
  </div>

  <div class="w-full md:w-4/12 px-4 text-center">
    <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
      <div class="px-4 py-5 flex-auto">
        <div
          class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-lightBlue-400">
          <i class="fas fa-images"></i>
        </div>
        <p class="font-bold text-blueGray-700 mt-8" *ngIf='titles'>
          {{titles[1]}}
        </p>
        <p class="mt-2 mb-4 text-blueGray-500" *ngIf='titles'>
          {{texts[1]}}
        </p>
      </div>
    </div>
  </div>
  <div class="w-full md:w-4/12 px-4 text-center">
    <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-lg">
      <div class="px-4 py-5 flex-auto">
        <div
          class="text-white p-3 text-center inline-flex items-center justify-center w-12 h-12 mb-5 shadow-lg rounded-full bg-emerald-400">
          <i class="fas fa-music"></i>
        </div>
        <p class="font-bold text-blueGray-700 mt-8" *ngIf='titles'>
          {{titles[2]}}
        </p>
        <p class="mt-2 mb-4 text-blueGray-500" *ngIf='titles'>
          {{texts[2]}}
        </p>
      </div>
    </div>
  </div>
</div>

